export default __webpack_public_path__ + "static/media/Login.aa613291.png";